// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Global variables */
  --terbine-blue: #306fba;
  --terbine-dark-gray: #474747;
  --terbine-light-gray: #ebebeb;
  --terbine-light-gray-2: #ebeff3;
  --terbine-white: #ebeff3;
  --header-yellow: #FBC900;
  --header-red: #C10A00;
  --header-blue: #001EFB;
  --header-green: #12C300;

  /* Included for Inter font support */
  font-feature-settings: "liga" 1, "calt" 1; /* fix for Chrome */
}

/* Included for Inter font support */
@supports (font-variation-settings: normal) {
  :root {
    font-family: InterVariable, sans-serif;
  }
}

/* Classes for Oxygen font support */
.oxygen-light {
  font-family: "Oxygen", serif;
  font-weight: 300;
  font-style: normal;
}
.oxygen-regular {
  font-family: "Oxygen", serif;
  font-weight: 400;
  font-style: normal;
}
.oxygen-bold {
  font-family: "Oxygen", serif;
  font-weight: 700;
  font-style: normal;
}

/* Classes for Roboto font support */
/* <weight>: Use a value from 100 to 900 */
/* <uniquifier>: Use a unique and descriptive class name */

/*.roboto-<uniquifier> {
  font-family: "Roboto", serif;
  font-optical-sizing: auto;
  font-weight: <weight>;
  font-style: normal;
  font-variation-settings:
    "wdth" 100;
}*/

/* Default styling from create-react-app */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: Roboto, Oxygen, Inter, Ubuntu, Cantarell, Fira Sans,
    -apple-system, BlinkMacSystemFont, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

/* Default styling from Figma files */
a,
button,
input,
select,
h1,
h2,
h3,
h4,
h5,
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: none;
  text-decoration: none;
  background: none;

  -webkit-font-smoothing: antialiased;
}

a {
  color: inherit;
}

menu,
ol,
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

/* Overrides for Material-UI components */
.MuiAutocomplete-tag {
  max-width: 150px !important;
}

/* .MuiTableRow-root {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
} */

.MuiFormControl-root,
.MuiOutlinedInput-notchedOutline,
.MuiOutlinedInput-root,
.MuiInputBase-root {
  border-radius: 8px !important;
}

.MuiInputBase-input {
  color: #1e1e1e !important;
}

.MuiOutlinedInput-notchedOutline {
  border: 1px solid #d9d9d9 !important;
}

#manage-notification-configurations-table-header-row th.MuiTableCell-head {
  font-family: Inter, Oxygen, Roboto, sans-serif;
  font-size: 16px;
}

#manage-notification-configurations-table-container
  tbody
  > tr.config-row-header
  > td {
  padding: 16px;
}

ul.MuiList-root li, 
div.MuiAutocomplete-listbox li.MuiMenuItem-root {
  color: #1e1e1e;
}

ul.MuiList-root li.Mui-selected,
ul.MuiList-root li.MuiButtonBase-root.Mui-selected,
div.MuiAutocomplete-listbox li.MuiMenuItem-root[aria-selected=true]  {
  background: var(--terbine-blue);
  color: white;
}

ul.MuiList-root li:hover,
ul.MuiList-root li.Mui-selected:hover,
ul.MuiList-root li.MuiButtonBase-root.Mui-selected:hover,
div.MuiAutocomplete-listbox li.MuiMenuItem-root[aria-selected=true]:hover,
li.MuiButtonBase-root.MuiMenuItem-root.MuiAutocomplete-option[aria-selected=true]:hover,
li.MuiButtonBase-root.MuiMenuItem-root.MuiAutocomplete-option[aria-selected=true]:focus,
li.MuiAutocomplete-option.Mui-focused[aria-selected=true],
li.MuiMenuItem-root.Mui-focused[aria-selected=true] {
  background: lab(from var(--terbine-blue) calc(l - 5) a b / 100) !important;
  color: white;
}

ul.MuiList-root li.Mui-selected svg,
ul.MuiList-root li.MuiButtonBase-root.Mui-selected svg {
  fill: white;
}

#dashboard-alerts-table-head th,
#view-alerts-table-head th {
  font-family: Inter, Oxygen, Roboto, sans-serif;
  /* font-size: 18px; */
}

.dashboard-alerts-expanded-row *,
.view-alerts-expanded-row * {
  font-family: Inter, Oxygen, Roboto, sans-serif;
}

.dashboard-alerts-expanded-row .MuiInputBase-input,
.view-alerts-expanded-row .MuiInputBase-input {
  font-size: 12px;
}

.dashboard-alerts-notifications-table *,
.view-alerts-notifications-table * {
  font-family: Inter, Oxygen, Roboto, sans-serif !important;
}

/* Styling related to map styling */
.custom-marker-clustering-control-panel .attribution {
  font-size: 0.75em;
}

@keyframes appear {
  from {
    opacity: 0.5;
    scale: 0.8;
  }
  80% {
    scale: 1.05;
  }
  to {
    opacity: 1;
    scale: 1;
  }
}

.map-view-map {
  width: 100vw;
  /* height: 100vh; */
}

.map-view-map .marker {
  box-sizing: border-box;
  border-radius: 50%;

  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  animation: appear 150ms both;
}

.map-view-map .marker img {
  border-radius: 50%;
}

.dashboard-map,
.admin-settings-map,
.notification-configurations-map {
  height: 100%;
  width: 100%;
}

.main-screen-marker {
  box-sizing: border-box;
  border-radius: 50%;

  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

@keyframes breatheRed {
  0% {
    scale: 1;
    box-shadow: 0 0 0 #be1716;
  }
  50% {
    scale: 1.5;
    box-shadow: 0 0 10px #be1716;
  }
  100% {
    scale: 1;
    box-shadow: 0 0 0 #be1716;
  }
}

@keyframes breatheYellow {
  0% {
    scale: 1;
    box-shadow: 0 0 0 #fac738;
  }
  50% {
    scale: 1.5;
    box-shadow: 0 0 10px #fac738;
  }
  100% {
    scale: 1;
    box-shadow: 0 0 0 #fac738;
  }
}

.main-screen-marker-red {
  animation: breatheRed 2s ease 0s infinite;
}

.main-screen-marker-yellow {
  animation: breatheYellow 2s ease 0s infinite;
}

/* Default styling */
/* Below creates unwanted gutter on console/map page */
/* html {
  scrollbar-gutter: stable both-edges;
} */
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;;EAEvB,oCAAoC;EACpC,yCAAyC,EAAE,mBAAmB;AAChE;;AAEA,oCAAoC;AACpC;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA,oCAAoC;AACpC;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC,0CAA0C;AAC1C,0DAA0D;;AAE1D;;;;;;;EAOE;;AAEF,0CAA0C;AAC1C;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;iDAC+C;EAC/C,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,qCAAqC;AACrC;;;;;;;;;;EAUE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;;EAEhB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;AAC7B;;AAEA;;;GAGG;;AAEH;;;;EAIE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;;;;;;;;EAQE,0EAA0E;EAC1E,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,yDAAyD;AAC3D;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,QAAQ;EACV;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;;EAElB,aAAa;EACb,wBAAwB;EACxB,mBAAmB;;EAEnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;;EAElB,aAAa;EACb,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE;IACE,QAAQ;IACR,yBAAyB;EAC3B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,QAAQ;IACR,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,QAAQ;IACR,yBAAyB;EAC3B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,QAAQ;IACR,yBAAyB;EAC3B;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,oBAAoB;AACpB,sDAAsD;AACtD;;GAEG","sourcesContent":[":root {\n  /* Global variables */\n  --terbine-blue: #306fba;\n  --terbine-dark-gray: #474747;\n  --terbine-light-gray: #ebebeb;\n  --terbine-light-gray-2: #ebeff3;\n  --terbine-white: #ebeff3;\n  --header-yellow: #FBC900;\n  --header-red: #C10A00;\n  --header-blue: #001EFB;\n  --header-green: #12C300;\n\n  /* Included for Inter font support */\n  font-feature-settings: \"liga\" 1, \"calt\" 1; /* fix for Chrome */\n}\n\n/* Included for Inter font support */\n@supports (font-variation-settings: normal) {\n  :root {\n    font-family: InterVariable, sans-serif;\n  }\n}\n\n/* Classes for Oxygen font support */\n.oxygen-light {\n  font-family: \"Oxygen\", serif;\n  font-weight: 300;\n  font-style: normal;\n}\n.oxygen-regular {\n  font-family: \"Oxygen\", serif;\n  font-weight: 400;\n  font-style: normal;\n}\n.oxygen-bold {\n  font-family: \"Oxygen\", serif;\n  font-weight: 700;\n  font-style: normal;\n}\n\n/* Classes for Roboto font support */\n/* <weight>: Use a value from 100 to 900 */\n/* <uniquifier>: Use a unique and descriptive class name */\n\n/*.roboto-<uniquifier> {\n  font-family: \"Roboto\", serif;\n  font-optical-sizing: auto;\n  font-weight: <weight>;\n  font-style: normal;\n  font-variation-settings:\n    \"wdth\" 100;\n}*/\n\n/* Default styling from create-react-app */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: Roboto, Oxygen, Inter, Ubuntu, Cantarell, Fira Sans,\n    -apple-system, BlinkMacSystemFont, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n/* Default styling from Figma files */\na,\nbutton,\ninput,\nselect,\nh1,\nh2,\nh3,\nh4,\nh5,\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  border: none;\n  text-decoration: none;\n  background: none;\n\n  -webkit-font-smoothing: antialiased;\n}\n\na {\n  color: inherit;\n}\n\nmenu,\nol,\nul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n/* Overrides for Material-UI components */\n.MuiAutocomplete-tag {\n  max-width: 150px !important;\n}\n\n/* .MuiTableRow-root {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n} */\n\n.MuiFormControl-root,\n.MuiOutlinedInput-notchedOutline,\n.MuiOutlinedInput-root,\n.MuiInputBase-root {\n  border-radius: 8px !important;\n}\n\n.MuiInputBase-input {\n  color: #1e1e1e !important;\n}\n\n.MuiOutlinedInput-notchedOutline {\n  border: 1px solid #d9d9d9 !important;\n}\n\n#manage-notification-configurations-table-header-row th.MuiTableCell-head {\n  font-family: Inter, Oxygen, Roboto, sans-serif;\n  font-size: 16px;\n}\n\n#manage-notification-configurations-table-container\n  tbody\n  > tr.config-row-header\n  > td {\n  padding: 16px;\n}\n\nul.MuiList-root li, \ndiv.MuiAutocomplete-listbox li.MuiMenuItem-root {\n  color: #1e1e1e;\n}\n\nul.MuiList-root li.Mui-selected,\nul.MuiList-root li.MuiButtonBase-root.Mui-selected,\ndiv.MuiAutocomplete-listbox li.MuiMenuItem-root[aria-selected=true]  {\n  background: var(--terbine-blue);\n  color: white;\n}\n\nul.MuiList-root li:hover,\nul.MuiList-root li.Mui-selected:hover,\nul.MuiList-root li.MuiButtonBase-root.Mui-selected:hover,\ndiv.MuiAutocomplete-listbox li.MuiMenuItem-root[aria-selected=true]:hover,\nli.MuiButtonBase-root.MuiMenuItem-root.MuiAutocomplete-option[aria-selected=true]:hover,\nli.MuiButtonBase-root.MuiMenuItem-root.MuiAutocomplete-option[aria-selected=true]:focus,\nli.MuiAutocomplete-option.Mui-focused[aria-selected=true],\nli.MuiMenuItem-root.Mui-focused[aria-selected=true] {\n  background: lab(from var(--terbine-blue) calc(l - 5) a b / 100) !important;\n  color: white;\n}\n\nul.MuiList-root li.Mui-selected svg,\nul.MuiList-root li.MuiButtonBase-root.Mui-selected svg {\n  fill: white;\n}\n\n#dashboard-alerts-table-head th,\n#view-alerts-table-head th {\n  font-family: Inter, Oxygen, Roboto, sans-serif;\n  /* font-size: 18px; */\n}\n\n.dashboard-alerts-expanded-row *,\n.view-alerts-expanded-row * {\n  font-family: Inter, Oxygen, Roboto, sans-serif;\n}\n\n.dashboard-alerts-expanded-row .MuiInputBase-input,\n.view-alerts-expanded-row .MuiInputBase-input {\n  font-size: 12px;\n}\n\n.dashboard-alerts-notifications-table *,\n.view-alerts-notifications-table * {\n  font-family: Inter, Oxygen, Roboto, sans-serif !important;\n}\n\n/* Styling related to map styling */\n.custom-marker-clustering-control-panel .attribution {\n  font-size: 0.75em;\n}\n\n@keyframes appear {\n  from {\n    opacity: 0.5;\n    scale: 0.8;\n  }\n  80% {\n    scale: 1.05;\n  }\n  to {\n    opacity: 1;\n    scale: 1;\n  }\n}\n\n.map-view-map {\n  width: 100vw;\n  /* height: 100vh; */\n}\n\n.map-view-map .marker {\n  box-sizing: border-box;\n  border-radius: 50%;\n\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n\n  animation: appear 150ms both;\n}\n\n.map-view-map .marker img {\n  border-radius: 50%;\n}\n\n.dashboard-map,\n.admin-settings-map,\n.notification-configurations-map {\n  height: 100%;\n  width: 100%;\n}\n\n.main-screen-marker {\n  box-sizing: border-box;\n  border-radius: 50%;\n\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n}\n\n@keyframes breatheRed {\n  0% {\n    scale: 1;\n    box-shadow: 0 0 0 #be1716;\n  }\n  50% {\n    scale: 1.5;\n    box-shadow: 0 0 10px #be1716;\n  }\n  100% {\n    scale: 1;\n    box-shadow: 0 0 0 #be1716;\n  }\n}\n\n@keyframes breatheYellow {\n  0% {\n    scale: 1;\n    box-shadow: 0 0 0 #fac738;\n  }\n  50% {\n    scale: 1.5;\n    box-shadow: 0 0 10px #fac738;\n  }\n  100% {\n    scale: 1;\n    box-shadow: 0 0 0 #fac738;\n  }\n}\n\n.main-screen-marker-red {\n  animation: breatheRed 2s ease 0s infinite;\n}\n\n.main-screen-marker-yellow {\n  animation: breatheYellow 2s ease 0s infinite;\n}\n\n/* Default styling */\n/* Below creates unwanted gutter on console/map page */\n/* html {\n  scrollbar-gutter: stable both-edges;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
